import { render, staticRenderFns } from "./AsiCardDetail.vue?vue&type=template&id=445b7a44&scoped=true"
import script from "./AsiCardDetail.vue?vue&type=script&lang=ts"
export * from "./AsiCardDetail.vue?vue&type=script&lang=ts"
import style0 from "./AsiCardDetail.vue?vue&type=style&index=0&id=445b7a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b7a44",
  null
  
)

export default component.exports